module.exports = __webpack_public_path__ + "img/app-91porn.5b7ead0b.png";